import { HEALTH_ENROLLMENT_STATUSES } from 'platform/shared/health-apps';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { selectHealthEnrollmentStatus } from '../../../selectors';
import ServerErrorAlert from '../../FormAlerts/ServerErrorAlert';
import EnrollmentStatusFAQ from './FAQ';
import ReapplyButton from './Warning/ReapplyButton';
import WarningExplanation from './Warning/WarningExplanation';
import WarningHeadline from './Warning/WarningHeadline';
import WarningStatus from './Warning/WarningStatus';

const INFO_ALERT_STATUS_CODES = new Set([
  HEALTH_ENROLLMENT_STATUSES.pendingOther,
  HEALTH_ENROLLMENT_STATUSES.pendingUnverified,
  HEALTH_ENROLLMENT_STATUSES.pendingPurpleHeart,
]);

export const getEnrollmentAlertStatus = parsedStatus => {
  if (parsedStatus === HEALTH_ENROLLMENT_STATUSES.enrolled) return 'continue';
  if (INFO_ALERT_STATUS_CODES.has(parsedStatus)) return 'info';
  return 'warning';
};

const EnrollmentStatus = ({ route }) => {
  const { parsedStatus, hasServerError } = useSelector(
    selectHealthEnrollmentStatus,
  );
  const alertStatus = getEnrollmentAlertStatus(parsedStatus);

  if (hasServerError) return <ServerErrorAlert />;

  return (
    <>
      <va-alert status={alertStatus} data-testid="hca-enrollment-alert">
        <WarningHeadline />
        <WarningStatus />
        <WarningExplanation />
        <ReapplyButton route={route} />
      </va-alert>

      <EnrollmentStatusFAQ />
    </>
  );
};

EnrollmentStatus.propTypes = {
  route: PropTypes.object,
};

export default EnrollmentStatus;
